module.exports = __webpack_public_path__ + "img/aboutBg.7ef7c15a.jpg";